import {
  init_helperFunctions
} from "./chunk-DW4SJM6G.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/copyTextureToTexture.fragment.js
var name, shader, copyTextureToTexturePixelShader;
var init_copyTextureToTexture_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/copyTextureToTexture.fragment.js"() {
    init_shaderStore();
    init_helperFunctions();
    name = "copyTextureToTexturePixelShader";
    shader = `uniform float conversion;uniform sampler2D textureSampler;varying vec2 vUV;
#include<helperFunctions>
void main(void) 
{vec4 color=texture2D(textureSampler,vUV);
#ifdef DEPTH_TEXTURE
gl_FragDepth=color.r;
#else
if (conversion==1.) {color=toLinearSpace(color);} else if (conversion==2.) {color=toGammaSpace(color);}
gl_FragColor=color;
#endif
}
`;
    ShaderStore.ShadersStore[name] = shader;
    copyTextureToTexturePixelShader = { name, shader };
  }
});

export {
  copyTextureToTexturePixelShader,
  init_copyTextureToTexture_fragment
};
